export default "__VITE_ASSET__RjwBJhrz__"